import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Cookie consent notice (PRD Module 7.19). We only use essential cookies/local
// storage, so this is a notice with acknowledgement rather than a consent gate.
const KEY = 'webfoxx.cookieNotice';

export function CookieConsent() {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(KEY) === 'ack'; } catch { return true; }
  });
  if (dismissed) return null;

  const accept = () => {
    try { localStorage.setItem(KEY, 'ack'); } catch { /* storage blocked — hide anyway */ }
    setDismissed(true);
  };

  return (
    <div className="cookie-consent" role="region" aria-label="Cookie notice">
      <p>
        We use essential cookies to keep you signed in and remember your preferences. No advertising
        or third-party tracking. See our <Link to="/privacy">Privacy Policy</Link>.
      </p>
      <button className="primary-action compact" onClick={accept}>Got it</button>
    </div>
  );
}
